import { useFlag } from '@mentimeter/flags/confidence/client';

export const useEditorChecklistExperiment = (): boolean => {
  const { value: showEditorChecklist } = useFlag(
    'nux-editor-checklist.enabled',
    false,
  );
  return showEditorChecklist;
};
